import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { provideTranslocoScope } from '@ngneat/transloco';
import { FormWithEmail } from '@platform-frontend/ui-tools';
import { TypedChanges } from '@platform-frontend/util';
import { ACCOUNT_UI_MATOMO_EVENT_CATEGORY_ACCOUNT } from '../account-ui-matomo-events';
import { ACCOUNT_UI_TRANSLOCO_SCOPE } from '../account-ui-transloco-scope';

@Component({
  selector: 'yat-forgot-password-form',
  templateUrl: './forgot-password-form.component.html',
  styleUrls: ['./forgot-password-form.component.scss'],
  providers: [provideTranslocoScope(ACCOUNT_UI_TRANSLOCO_SCOPE)]
})
export class ForgotPasswordFormComponent implements OnChanges {
  @Output()
  requestReset: EventEmitter<string> = new EventEmitter();

  @Input()
  emailControl: FormControl<string>;

  readonly MATOMO_EVENT_CATEGORY_ACCOUNT = ACCOUNT_UI_MATOMO_EVENT_CATEGORY_ACCOUNT;

  forgotPasswordForm = new FormGroup<FormWithEmail>({
    email: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.email] })
  });

  ngOnChanges(changes: TypedChanges<ForgotPasswordFormComponent>): void {
    if (changes.emailControl) {
      // Replace the whole form here. Otherwise email changes are not recognized after the first unsuccessfull call of submitForm().
      this.forgotPasswordForm = new FormGroup({
        email: this.emailControl
      });
    }
  }

  submitForm(value: { email: string }): void {
    this.requestReset.next(value.email);
  }
}
